import React, { Component } from "react";
import { ClickAwayListener } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import "../styles/customSelect.scss";
import InfoBarSelection from "./InfoBarSelection";
import BounceLoader from "react-spinners/BounceLoader";

import SearchBar from "./SearchBar";

export default class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      checkboxSelection: {},
      localValues: [],
      searchTerm: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    if (this.props.item.value !== prevProps.item.value)
      this.setState({
        localValues: isMultiSelect //for synching with parent's value after category filter clear
          ? this.props.item.value //if multi-select,push entire selection list
          : this.props.item.value.length === 0 //if single-select ...
          ? [] //and empty then push an empty array
          : [this.props.item.value], //or push the only value for single-select
      });
  }

  toggleOpen = (e) => {
    this.setState({ searchTerm: "" });
    if (this.props.item.options?.length === 0) return;
    if (this.state.isOpen) return;
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };
  onChange = (selection) => {
    const isMultiSelect = this.props.isMultiSelect;
    if (isMultiSelect && isMultiSelect === true) {
      this.toggleCheckBox(selection);
    } else this.changleSingleSelectValue(selection);
  };

  changleSingleSelectValue = (selection) => {
    this.setState({ localValues: [selection.id] }, () => this.onConfirm());
  };

  toggleAllCheckbox = () => {
    const options = this.props.item.options;
    this.setState({ searchTerm: "" });
    var values = [];
    if (this.state.localValues.length !== options.length)
      //if all not selected
      options.map((option) => {
        values.push(option.id);
      });
    this.setState({ localValues: values });
  };

  toggleCheckBox = (selection) => {
    //console.log(selection);
    const values = this.state.localValues;
    if (!values.includes(selection.id)) {
      values.push(selection.id);
    } else {
      const index = values.indexOf(selection.id);
      // console.log(index);
      if (index > -1) {
        // only splice array when item is found
        values.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    this.setState({ localValues: values });
  };

  onSearch = (e) => {
    this.setState({ searchTerm: e.target.value.toLowerCase() });
  };

  filterSearch = (i) => {
    if (this.state.searchTerm === "") return true;
    return i.name.toLowerCase().includes(this.state.searchTerm);
  };

  onConfirm = () => {
    this.setState({ isOpen: false });
    var selectionList = [...this.state.localValues];

    //MULTI-SELECT;
    if (this.props.isMultiSelect && this.props.isMultiSelect === true) {
      this.props.handleChange({ target: { value: selectionList } });
    }
    //SINGLE-SELECT
    else this.props.handleChange({ target: { value: selectionList[0] } });
  };

  onClickAway = () => {
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    if (
      !isMultiSelect ||
      (this.state.localValues.length === 0 && isMultiSelect)
    )
      this.setState({ isOpen: false });
  };

  render() {
    const item = this.props.item;
    const isOpen = this.state.isOpen;
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    const values = this.state.localValues;

    return (
      <div
        className={
          isOpen ? "custom-select-container active" : "custom-select-container"
        }
        onClick={this.toggleOpen}
        style={{
          cursor: item?.options?.length ? "pointer" : "not-allowed",
          backgroundColor: item?.options?.length ? "" : "rgb(237 239 245)",
        }}
      >
        {!item.options && (
          <div className="select-spinners-containers">
            <BounceLoader size={20} />
          </div>
        )}
        <InfoBarSelection
          isActive={item?.options?.length}
          item={item}
          values={values}
        />

        {item && item.options && item.options.length !== 0 && isOpen && (
          <ClickAwayListener onClickAway={this.onClickAway}>
            <div className="selection-overlay">
              {item.options.length > 5 && (
                <div className="customselect-search-bar-container">
                  {" "}
                  <SearchBar
                    value={this.state.searchTerm}
                    onChange={this.onSearch}
                  />
                </div>
              )}
              {isMultiSelect && (
                <div
                  onClick={this.toggleAllCheckbox}
                  className="custom-select-all"
                  style={{ marginBottom: 10 }}
                >
                  {item.options.length === this.state.localValues.length
                    ? "Deselect All"
                    : "Select All"}
                </div>
              )}
              <div className="options-list-select">
                {item.options.filter(this.filterSearch).map((option) => {
                  //
                  const status = values.includes(option.id);

                  //
                  return (
                    <div
                      key={option.id}
                      className={
                        !status ? "option-select" : "option-select active"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        this.onChange(option);
                      }}
                    >
                      {isMultiSelect && (
                        <Checkbox
                          //   checked={item.value.indexOf(option.id) > -1}
                          checked={status}
                        />
                      )}
                      {option.name}
                    </div>
                  );
                })}
              </div>
              {isMultiSelect && (
                <button
                  onClick={this.onConfirm}
                  className="confirm-button"
                  //disabled={values.length === 0}
                >
                  Done
                </button>
              )}
            </div>
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

// const InfoBarSelection = ({ item, values }) => {
//   // console.log(values);
//   return (
//     <div className="info-bar-selection-container">
//       {item.icon && <img src={item.icon} />}
//       <div className="info">
//         <p className={values.length > 0 ? "label small" : "label"}>
//           {item.label}
//         </p>
//         {values.length > 0 && (
//           <p className="selection">{formatSelections(values, item.options)}</p>
//         )}
//       </div>
//     </div>
//   );
// };
